import { EventEmitter, Injectable } from '@angular/core';
import { IClientDto } from '../../models/client.dto';
import { EventEmitterContract } from './event-emitter.contract';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService implements EventEmitterContract {
  selectClientSearchTableEmit = new EventEmitter<IClientDto>;

  selectClientSearchTable(selectedClient: IClientDto) {
    this.selectClientSearchTableEmit.emit(selectedClient);
  }
}